import Exception from '@/exceptions/Exception'
import { i18n } from '@/plugins/i18n'

export default class TooManyRequestException extends Exception {
	constructor () {
		super(i18n.t('errors.too_many_request'), 'TooManyRequestException')
	}
}
